<template>
    <div  v-if="isLargeScreen">

        <div>
            <Breadcrumbs main="Transactions" title="Transactions" />

            <div class="container-fluid">
                <div class="row widget-grid m-lg-5">
                    <DataTable />
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <MobileTransaction />
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue';
import DataTable from './dataTable.vue';
import MobileTransaction from './mobile/index.vue'


const isLargeScreen = ref(true);
  
  // 檢查螢幕大小
  function checkScreenSize() {
    isLargeScreen.value = window.innerWidth >= 992;
  }
  
  onMounted(() => {
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
  });
  
  onUnmounted(() => {
    window.removeEventListener('resize', checkScreenSize);
  });
</script>